<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { userwxlogin, usercenterinfo, getShareInfo, siteurl } from "@/api/home";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      this.getShareInfo();
      let code = this.getQueryString("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      // code='091grf000i8UBL1TGH300vl0Hz1grf0C'
      const local = window.location.href;
      if (
        this.$route.path == "/" ||
        this.$route.path == "/index" ||
        this.$route.path == "/declareindex" ||
        this.$route.path == "/declare" ||
        this.$route.path == "/indexvideo" ||
        this.$route.path == "/video"
      ) {
        if (
          localStorage.getItem("openid") == "" ||
          localStorage.getItem("openid") == null ||
          localStorage.getItem("openid") == undefined
        ) {
          if (code == null || code === "") {
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri=" +
              encodeURIComponent(local) +
              "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
          } else {
            this.getOpenId(code);
          }
        }
      }
    },
  },
  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
      let code = this.getQueryString("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      // code='091grf000i8UBL1TGH300vl0Hz1grf0C'
      const local = window.location.href;
      if (
        (code == null || code === ""||code==undefined) &&
        (localStorage.getItem("openid") == "" ||
          localStorage.getItem("openid") == null||
        localStorage.getItem("token") == null||
        localStorage.getItem("token") == '')
      ) {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
      } else {
        if (code == null || code === "") {
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri=" +
            encodeURIComponent(local) +
            "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
        } else {
          this.getOpenId(code);
        }
      }
    },
    getOpenId() {
      // userwxlogin
      let that = this;
      let params = {
        appId: "wx29b2bf8c2c033c0d",
        code: this.getQueryString("code"),
      };

      that.loading = true;
      userwxlogin(params)
        .then((res) => {
          localStorage.setItem("openid", res.data.data.openid);
          if (res.data.data.token) {
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem(
              "isSettingPwdQuestion",
              res.data.data.isSettingPwdQuestion
            );
            localStorage.setItem("roleType", res.data.data.roleType);
            localStorage.setItem("userId", res.data.data.userId);
            // that.usercenterinfo();
            if (
              res.data.data.token
            ) {
              that.usercenterinfo();
            }
          }
        })
        .catch(() => {});
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    usercenterinfo() {
      let that = this;
      usercenterinfo()
        .then((res) => {
          localStorage.setItem(
            "headPhotoUrl",
            res.data.data.teacher.headPhotoUrl
          );
          localStorage.setItem("name", res.data.data.teacher.name);
          localStorage.setItem("schoolName", res.data.data.teacher.schoolName);
          localStorage.setItem("userId", res.data.data.userId);
          localStorage.setItem("roleType", res.data.data.roleType);
          localStorage.setItem("schoolId", res.data.data.schoolId);
          localStorage.setItem("groupId", res.data.data.groupId);
        })
        .catch(() => {});
    },
    getShareInfo() {
      var params = {
        //请求参数
        url: window.location.href.split("#")[0],
      };
      let that = this;
      let tit = "测试分享";
      let local = window.location.href;
      let fxUrl = window.location.href;
      fxUrl = fxUrl.match(/#(\S*)/)[1];
      fxUrl = siteurl + "#" + fxUrl;
      getShareInfo(params).then((res) => {
        let appId = res.data.data.appid;
        let timestamp = res.data.data.timestamp;
        let nonceStr = res.data.data.noncestr;
        let signature = res.data.data.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识，填自己的！
          timestamp: timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: [
            "onMenuShareTimeline", // 分享到朋友圈
            "onMenuShareAppMessage", // 分享到微信好友
            "onMenuShareQQ", // 分享到QQ
            "onMenuShareWeibo", // 分享到微博
            "onMenuShareQZone", // 分享到空间
            "hideMenuItems", // 批量隐藏菜单
            "scanQRCode",
          ],
          openTagList: ['wx-open-launch-weapp']
        });

        wx.ready(function () {
          //分享给朋友
          wx.onMenuShareAppMessage({
            title: document.title, // 分享标题
            desc: document.title, // 分享描述
            link: fxUrl, // 分享链接
            imgUrl:
              "https://file.welaiedu.cn/Icon/aihuishiyuan.png", // 分享图标
            type: "link", // 分享类型,music、video或link，不填默认为link
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });

          wx.onMenuShareTimeline({
            title: document.title, // 分享标题
            link: fxUrl, // 分享链接
            imgUrl:
              "https://file.welaiedu.cn/Icon/M4Wk85AGph.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });
        });

        wx.error(function (res) {
          // alert(res.errMsg);
        });
      });
    },
  },
  components: {
    // 声明子组件名字
  },
  mounted() {
    this.getShareInfo();
     let code = this.getQueryString("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
     console.log(this.$route.path)
     console.log(localStorage.getItem("openid"))
     console.log(code)
     const local = window.location.href;
    if (
      this.$route.path == "/" ||
      this.$route.path == "/index" ||
      this.$route.path == "/declareindex" ||
      this.$route.path == "/declare" ||
      this.$route.path == "/indexvideo" ||
      this.$route.path == "/video"
    ) {
      if (
        localStorage.getItem("openid") == "" ||
        localStorage.getItem("openid") == null ||
        localStorage.getItem("openid") == undefined||
        localStorage.getItem("token") == null||
        localStorage.getItem("token") == ''
      ) {
        if (code == null || code === ""||code==undefined) {
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri=" +
            encodeURIComponent(local) +
            "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
        } else {
          this.getOpenId(code);
        }
      }
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue